import { Outlet } from 'react-router-dom';

export const EmptyLayout = () => {
  return (
    <div className="my-0 mx-auto flex justify-center items-center h-full min-h-screen">
      <Outlet />
    </div>
  );
};
